import React, {Component} from "react";
import {Control, Field, Icon, Select} from "bloomer";
import Card from "../../../elements/Card";
import Button from "../../../elements/Button";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import SectionName from "../../../elements/SectionName";
import Spacer from "../../../elements/Spacer";
import InformationCard from "../../../elements/InformationCard";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import {getTextCompletionResult} from "../../../api/models/TextCompletion";
import TemplatesConfig from "./TemplatesConfig";

interface ITextCompletionState {
    loading: boolean;
    inputComponent: any;
    inputComponentRef: any;
    selectedTemplate: string;
    result: string;
    errorMessage: string;
}

class TextCompletionModel extends Component<{}, ITextCompletionState> {

    public constructor(props: {}) {
        super(props);

        this.state = {
            loading: false,
            inputComponent: null,
            inputComponentRef: null,
            selectedTemplate: "general",
            result: "",
            errorMessage: ""
        };
    }

    public componentDidMount() {
        this.updateTemplateComponent();
        SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.TEXT_COMPLETION);
    }

    public updateTemplateComponent = () => {
        const templateId = this.state.selectedTemplate;
        const config: any = TemplatesConfig.find((t: any) => t.id === templateId);
        if (config) {
            const elementRef = React.createRef();
            const element = React.createElement(config.component, {
                ref: elementRef
            });

            this.setState({
                inputComponent: element,
                inputComponentRef: elementRef,
                result: "",
                errorMessage: ""
            });
        } else {
            this.setState({
                inputComponent: null,
                inputComponentRef: null,
                result: "",
                errorMessage: ""
            });
        }
    };

    public handleTemplateChange = (e: any) => {
        this.setState({
            selectedTemplate: e.target.value
        }, () => {
            this.updateTemplateComponent();
        });
    };

    public getCurrentForm = () => {
        const component = this.state.inputComponent;
        const componentRef = this.state.inputComponentRef;
        if (!component || !componentRef) {
            return null;
        }

        return componentRef.current;
    };

    public onSubmit = async (e: any) => {
        e.target.blur();

        if (this.state.loading) {
            return;
        }

        const form = this.getCurrentForm();
        if (!form) {
            return;
        }

        if (!form.validateForm()) {
            this.setState({result: ""});
            return;
        }

        const data = form.getFormData();
        data.template = this.state.selectedTemplate;

        this.setState({
            loading: true,
            result: "",
            errorMessage: ""
        });

        let errorOccurred = false;

        const response = await getTextCompletionResult(data).catch((error) => {
            if (ErrorUtils.requestLimitExceeded(error.response)) {
                this.setState({
                    loading: false
                });
                toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
            } else {
                this.setState({
                    loading: false,
                    errorMessage: "Couldn't process text."
                });
            }
            errorOccurred = true;
        });

        if (errorOccurred) {
            return;
        }

        if (response && response.data && response.data.choices && response.data.choices.length) {
            const choice = response.data.choices[0];
            if (choice.text) {
                this.setState({
                    loading: false,
                    result: choice.text
                });
            } else {
                this.setState({
                    loading: false,
                    errorMessage: "Couldn't process text."
                });
            }
        } else {
            this.setState({
                loading: false,
                errorMessage: "Couldn't process text."
            });
        }

        SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.TEXT_COMPLETION);
    };

    public resetState = async (e: any) => {
        e.target.blur();

        if (this.state.loading) {
            return;
        }

        this.setState({
            result: "",
            errorMessage: ""
        }, () => {
            const form = this.getCurrentForm();
            if (form) {
                form.resetForm();
            }
        });
    };

    public render() {
        return <ModelContentContainer>
            <Card>
                <Spacer/>
                <Field>
                    <SectionName>Template:</SectionName>
                    <Control>
                        <Select
                            value={this.state.selectedTemplate}
                            onChange={this.handleTemplateChange}
                        >
                            {
                                TemplatesConfig.map((item: any) => {
                                    return <option key={item.id} value={item.id}>{item.name}</option>;
                                })
                            }
                        </Select>
                    </Control>
                </Field>
                <Spacer/>
                {
                    this.state.inputComponent ? <React.Fragment>
                        {this.state.inputComponent}
                    </React.Fragment> : <></>
                }
                <div>
                    <Button onClick={this.onSubmit}>Submit</Button>
                    <Button onClick={this.resetState} style={{marginLeft: "5px"}}>Reset</Button>
                </div>
                <Spacer/>
                {
                    this.state.loading && <div>
                        <span>Loading...</span>
                        <Icon className="fas fa-spinner fa-spin"/>
                    </div>
                }
                {
                    !this.state.loading && this.state.result.length ? <div>
                        <SectionName>Output:</SectionName>
                        <InformationCard style={{whiteSpace: "pre-line"}}>
                            {this.state.result}
                        </InformationCard>
                    </div> : <></>
                }
                {
                    !this.state.loading && this.state.errorMessage ? <div>
                        <InformationCard>{this.state.errorMessage}</InformationCard>
                    </div> : <></>
                }
                <Spacer/>
            </Card>
        </ModelContentContainer>;
    }
}

export default TextCompletionModel;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextCompletion/TextCompletionModel.tsx